import * as React from 'react'
import MdButton from './MdButton'

class MdProgressModal extends React.Component<MdProgressModalProps, null> {

  constructor(props: any) {
    super(props)
  }

  public render() {
    let progressWidth = Math.round((this.props.currentTick / this.props.tickLength) * 100)
    return (
      <div>
        {(this.props.open) ?
          (<div className='mdConfirm'>
            <div className='mdConfirm-content' style={this.props.style}>
              <div className='mdConfirm-header'>
                {this.props.header}
              </div>
              <div className='mdConfirm-body'>
                <p>{this.props.confirmText || 'Please wait, your requested operation is in progress.'}</p>
                <div className='md-progress'>
                  <span style={{ width: `${progressWidth}%` }}></span>
                </div>
                {this.props.children}
                <br />
                {(this.props.cancelWarn)}
              </div>
              <div className='mdConfirm-footer'>
                {
                  this.props.currentTick !== this.props.tickLength && (
                    <MdButton
                      style={{
                        'boxShadow': 'inset 0 0 0 2px rgba(100, 100, 100, 0.6)',
                        'backgroundColor': 'transparent'
                      }}
                      text={(this.props.cancelText || 'Cancel')}
                      clickHandler={this.props.cancelCallback}
                    />
                  )
                }
                {
                  this.props.currentTick === this.props.tickLength && (
                    <MdButton
                      text={(this.props.confirmButtonText || 'Close')}
                      clickHandler={this.props.confirmCallback}
                    />
                  )
                }
                
              </div>
            </div>
          </div>)
        : null }
      </div>
    )
  }
}

export default MdProgressModal



// WEBPACK FOOTER //
// ./react/components/widgets/MdProgressModal.tsx